module.exports = __webpack_public_path__ + "static/media/06 Minutes of Meeting 07 Aug 2023.3bff0735.pdf";